import { ContattiIcon } from "../icone-utility/IcoCont";
import BackOrderIcon from "../icone-utility/IcoBO";
import TicketIcon from "../icone-utility/IcoTicket";
import RitiriIcon from "../icone-utility/IcoRitiri";
import RischioClientiIcon from "../icone-utility/IcoRC";
import MonitoraggioOrdini from "../icone-utility/IcoMonitord";
import ControlloOf from "../icone-utility/IcoSupplOrders";

export const utilityServices = [
  {
    title: "Contatti",
    desc: "Rubrica aziendale",
    icon: ContattiIcon,
    route: "/utility/add-contatti",
    group: "Gestione",
  },
  {
    title: "Ticket",
    desc: "Assistenza e supporto",
    icon: TicketIcon,
    route: "/utility/ticket",
    group: "Gestione",
  },

  {
    title: "Rischio Clienti",
    desc: "Gestione rischio clienti",
    icon: RischioClientiIcon,
    route: "/utility/rischio-clienti",
    group: "Commerciale",
  },

  {
    title: "Back Order",
    desc: "Ordini in arretrato",
    icon: BackOrderIcon,
    route: "/utility/backorder",
    group: "Logistica",
  },
  {
    title: "Ritiri",
    desc: "Gestione ritiri",
    icon: RitiriIcon,
    route: "/utility/ritiri",
    group: "Logistica",
  },
  {
    title: "Monitoraggio Ordini",
    desc: "Gestione monitoraggio ordini",
    icon: MonitoraggioOrdini,
    route: "/utility/monitoraggio-ordini",
    group: "Logistica",
  },
  {
    title: "Controllo ordini fornitori",
    desc: "Gestione controllo ordini fornitori",
    icon: ControlloOf,
    route: "/utility/controllo-ordini-fornitore",
    group: "Logistica",
  },
];

export const utilityGroups = [
  {
    title: "CRM",
    services: ["Contatti", "Back Order", "Rischio Clienti"]
  },
  {
    title: "Technoparts",
    services: ["Ticket"],
  },
  {
    title: "Fornitori",
    services: [
      "Ritiri",
      "Monitoraggio Ordini",
      "Controllo ordini fornitori",
    ],
  },
];